import React, { Component } from 'react';
import './FAQ.css';
import { GetCookie } from './utils/Common';
import { FetchData, UploadFile } from './utils/DataFetch';

export class ConfidentialityAgreement extends Component {
  static displayName = ConfidentialityAgreement.name;

  constructor(props) {
    super(props);
    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      accepted: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    FetchData('/getinterpreteritems', 'POST', this.user.token, { IntId: this.user.intid }).then((data) => {
      if (Array.isArray(data) && data.some((item) => item.intItemType === 'Confidentiality Agreement')) {
        this.setState({ accepted: true });
      }
    });
  }

  async handleChange(e) {
    if (!e.target.checked) return;

    const formData = new FormData();
    formData.append('EventType', 'insert');
    formData.append('IntItemId', null);
    formData.append('IntId', this.user.intid);
    formData.append('ItemName', 'Confidentiality Agreement');
    formData.append('ItemDescription', 'Interpreter Accepted Terms and Conditions');
    formData.append('Contact', '');
    formData.append('ContactEmail', '');
    formData.append('Notes', '');
    formData.append('FileLocation', '');
    formData.append('FileName', '');
    formData.append('IntItemType', 'Confidentiality Agreement');
    formData.append('CreateDateTime', null);
    formData.append('CreateByUserId', this.user.userid);
    formData.append('UpdateByUserId', null);
    formData.append('UpdateDateTime', null);
    formData.append('IsDeletedFlg', false);
    formData.append('FormFile', null);

    await UploadFile('/saveinterpreteritem', this.user.token, formData);
    this.setState({ accepted: true });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 120px)', padding: '20px', maxWidth: '852px', margin: '0 auto' }}>
        <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>Interpreter Confidentiality Agreement</h4>
        <div style={{ flex: 1, overflowY: 'auto', fontSize: '0.95rem', lineHeight: '1.6' }}>
          <p><strong>Executive Linguist Agency Inc.</strong></p>
          <p>
            As an interpreter or contractor working with Executive Linguist Agency Inc., I acknowledge
            that I may encounter Protected Health Information (PHI).
          </p>
          <p><strong>I agree to:</strong></p>
          <ul>
            <li>Maintain strict confidentiality of all patient information.</li>
            <li>Not disclose any PHI outside authorized interpreting assignments.</li>
            <li>Not record interpreting sessions unless explicitly authorized.</li>
            <li>Not store PHI on personal devices.</li>
            <li>Conduct remote interpreting in a private and secure environment.</li>
          </ul>
          <p>
            I understand that violation of this agreement may result in termination of my contract and
            possible legal action.
          </p>
        </div>
        <div style={{ marginTop: '16px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem' }}>
            <input
              type="checkbox"
              checked={this.state.accepted}
              disabled={this.state.accepted}
              onChange={this.handleChange}
            />
            I have read and agree to the Confidentiality Agreement
          </label>
        </div>
      </div>
    );
  }
}
